
function masterSelect() {
    var master = document.querySelectorAll("#masterselect option");

    var selected = document.querySelectorAll(".product-choice");
    var variantname = '';

    for (let i = 0; i < selected.length; i++) {
        const element = selected[i].value;
        if (i == selected.length - 1) {
            variantname = variantname + element;
        }
        else {
            variantname = variantname + element + ' / ';
        }
    }

    console.log(variantname);
    var choosen = false;
    var available = false;
    var id = "";
    var price = "";
    for (let j = 0; j < master.length; j++) {
        const element = master[j].getAttribute("data-index");
        console.log(element);
        if (element == variantname) {
            id = master[j].getAttribute("value");
            document.querySelector("#masterselect").value = id;
            price = master[j].getAttribute("data-price");
            var choosen = true;
            available = master[j].getAttribute("data-available");
        }
    }

    var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
    var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
    var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");

    if (choosen) {
        if (available == "true") {
            document.querySelector(".product--buy-button button").textContent = availabletext;
            document.querySelector(".product--buy-button button").removeAttribute("disabled");
        }
        else if (available == "false") {
            document.querySelector(".product--buy-button button").textContent = soldouttext;
            document.querySelector(".product--buy-button button").setAttribute("disabled", "disabled");
        }
    }
    else {
        document.querySelector(".product--buy-button button").textContent = unavailabletext;
        document.querySelector(".product--buy-button button").setAttribute("disabled", "disabled")
    }

    var nextURL = window.location.pathname + "?variant=" + id;
    window.history.replaceState("", "", nextURL);

    setTimeout(() => {
        document.querySelector(".rc-radio.rc-radio--active .price-label")
            ? document.querySelector(".product--price .textcolor").textContent = document.querySelector(".rc-radio.rc-radio--active .price-label").textContent
            : document.querySelector(".product--price .textcolor").textContent = price
    }, 500);
}


var swiper = new Swiper(".swiper-nav", {
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
});
var swiper2 = new Swiper(".swiper", {
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: {
        swiper: swiper,
    },
});

function addsize() {
    var input = document.querySelector(".changesize")
    var qty = parseInt(input.getAttribute("valuetext"));
    qty++;
    var max = parseInt(input.getAttribute("max"));
    if (qty <= max) {
        input.setAttribute("valuetext", qty);
        input.value = qty + ' Bags';
        masterSelect();
    }
}

function removesize() {
    var input = document.querySelector(".changesize")
    var qty = parseInt(input.getAttribute("valuetext"));
    qty--;
    if (qty >= 1) {
        input.setAttribute("valuetext", qty);
        if (qty == 1) {
            input.value = qty + ' Bag';
        } else {
            input.value = qty + ' Bags';
        }
        masterSelect();

    }
}

document.querySelectorAll(".product-option").forEach(function (option) {
    option.addEventListener("click", function () {
        this.parentElement.parentElement.querySelector(".active").classList.remove("active");
        this.classList.add("active");
        this.parentElement.parentElement.querySelector('.product-choice').value = this.getAttribute("data-value");
        masterSelect();
    })
});

var subscription = setInterval(() => {
    if ($(".rc-radio.rc-radio--active.subscription-radio").length) {
        $(".rc-radio.rc-radio--active.subscription-radio .rc-radio__label").append(`<div class="custom_subscription_text"><span><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_10_351" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10"><rect width="10" height="10" fill="#D9D9D9"/></mask><g mask="url(#mask0_10_351)"><path d="M5.00125 9.40221C4.45212 9.40221 3.93737 9.29835 3.457 9.09062C2.97662 8.88289 2.55822 8.6008 2.20179 8.24437C1.84536 7.88794 1.56328 7.46953 1.35554 6.98916C1.14781 6.50878 1.04395 5.9964 1.04395 5.45201H2.14813C2.14813 6.24483 2.42483 6.91737 2.97824 7.46964C3.53164 8.0219 4.20557 8.29803 5.00003 8.29803C5.79285 8.29803 6.46539 8.02133 7.01764 7.46792C7.56991 6.91452 7.84604 6.24058 7.84604 5.44613C7.84604 4.65331 7.56934 3.98078 7.01593 3.42851C6.46253 2.87625 5.7886 2.60012 4.99414 2.60012H4.92576L5.52449 3.19884L4.87638 3.86778L3.05662 2.04803L4.87638 0.228271L5.52449 0.903095L4.93164 1.49594H4.99414C5.54356 1.49594 6.05818 1.5998 6.538 1.80753C7.01782 2.01526 7.43694 2.29734 7.79533 2.65377C8.15372 3.01021 8.43678 3.42775 8.64451 3.9064C8.85224 4.38505 8.95611 4.89841 8.95611 5.44648C8.95611 5.99456 8.85224 6.50878 8.64451 6.98916C8.43678 7.46953 8.1547 7.88794 7.79827 8.24437C7.44184 8.6008 7.02384 8.88289 6.54427 9.09062C6.06471 9.29835 5.55037 9.40221 5.00125 9.40221Z" fill="black" fill-opacity="0.2"/></g></svg></span>
        <span class="fz-10" style="opacity: 0.2">Subscription renews 30 Days</span>
        <br>
        <div class="span">
            <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_7_139" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12"><rect width="12" height="12" fill="#D9D9D9"/></mask><g mask="url(#mask0_7_139)"><path d="M4.77501 9.2261L1.69891 6.15L2.64458 5.20433L4.77501 7.33477L9.35545 2.75433L10.3011 3.7L4.77501 9.2261Z" fill="#294EBC"/></g></svg></span>
            <span class="fz-10 fw-500">Cancel whenever you want.</span>
            <br>
            <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_7_139" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12"><rect width="12" height="12" fill="#D9D9D9"/></mask><g mask="url(#mask0_7_139)"><path d="M4.77501 9.2261L1.69891 6.15L2.64458 5.20433L4.77501 7.33477L9.35545 2.75433L10.3011 3.7L4.77501 9.2261Z" fill="#294EBC"/></g></svg></span>
            <span class="fz-10 fw-500">Your coffee at a special price</span>
            <br>
            <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_7_139" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12"><rect width="12" height="12" fill="#D9D9D9"/></mask><g mask="url(#mask0_7_139)"><path d="M4.77501 9.2261L1.69891 6.15L2.64458 5.20433L4.77501 7.33477L9.35545 2.75433L10.3011 3.7L4.77501 9.2261Z" fill="#294EBC"/></g></svg></span>
            <span class="fz-10 fw-500">Change coffee or quantity when you need</span>
            <br>
            <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_7_139" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12"><rect width="12" height="12" fill="#D9D9D9"/></mask><g mask="url(#mask0_7_139)"><path d="M4.77501 9.2261L1.69891 6.15L2.64458 5.20433L4.77501 7.33477L9.35545 2.75433L10.3011 3.7L4.77501 9.2261Z" fill="#294EBC"/></g></svg></span>
            <span class="fz-10 fw-500">Arrives fresh at your home</span>
        </div>
        </div>`);

        document.querySelectorAll(".rc-radio__input").forEach(function (input) {
            input.addEventListener("change", function () {
                masterSelect();
            })
        })
        clearInterval(subscription);
    }
}, 100);
